import { createPublicClient, http } from 'viem'
import { arbitrumSepolia } from 'viem/chains'

export const ethClient = createPublicClient({
  chain: arbitrumSepolia,
  transport: http(
    'https://arb-sepolia.g.alchemy.com/v2/qhUlv79pBClUQqtxpA5lITdEXhxTuKhB'
  )
})
